import axios from 'axios'
import { apiRoot } from './config.js'

export default class Api {
  
  get(path) {
    return axios.get(apiRoot + path, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': 0
      }
    })
    .then(response => {
      return response.data
    })
    .catch(error => error.response)
  }

  post(url, body) {
    return axios.post(url, body)
  }

  put(path, body) {
    return axios.put(apiRoot + path, body)
  }

  delete(path, body) {
    return axios.delete(apiRoot + path, { data: body })
  }

  fetchData() {
    return this.get('/5e76350d2f0000f157985ff6')
  }

  uploadImg(base64) {
    return this.post('https://o9w1g.sse.codesandbox.io/convert', {
      base64
    })
  }

  
}
